import React, { useState } from 'react';
import './OpenSearchAdmin.css';

const IPS = (process.env.REACT_APP_NAT_IPS || '').split(',').map(s => s.trim()).filter(Boolean);

// DNS records are supplied as comma-separated `Label|URL` entries (e.g.
// "Sync|https://dev-euw1-sync.hconnect.io"). Add more via REACT_APP_DNS_RECORDS as needed.
const DNS_RECORDS = (process.env.REACT_APP_DNS_RECORDS || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .map(entry => {
        const [label, url] = entry.split('|').map(x => x.trim());
        return url ? { label, url } : { label: entry, url: entry };
    });

// Health-check curl example for the sync API (built from the Sync DNS record).
const SYNC_URL = (DNS_RECORDS.find(r => r.label.toLowerCase() === 'sync') || {}).url || '';
const SYNC_HEALTH_CURL = SYNC_URL ? `curl ${SYNC_URL.replace(/\/$/, '')}/health` : '';

export default function DnsAndIp() {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(SYNC_HEALTH_CURL).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const codeChip = { fontFamily: 'monospace', fontSize: '0.85em', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 4, padding: '1px 5px', color: '#111827' };

    return (
        <div className="acp-page" style={{ maxWidth: 720 }}>
            <div className="acp-header">
                <h1 className="acp-title">DNS and IP</h1>
            </div>
            <div className="acp-card">
                <div className="acp-card-header">
                    <span className="acp-card-title">NAT Gateway IPs</span>
                    <span className="os-doc-count">{IPS.length} address{IPS.length !== 1 ? 'es' : ''}</span>
                </div>
                {IPS.length === 0 ? (
                    <div className="acp-empty">No NAT IPs configured</div>
                ) : (
                    <table className="acp-table">
                        <thead>
                            <tr><th>#</th><th>IP Address</th></tr>
                        </thead>
                        <tbody>
                            {IPS.map((ip, i) => (
                                <tr key={ip}>
                                    <td style={{ color: '#9ca3af', width: 40 }}>{i + 1}</td>
                                    <td style={{ fontFamily: 'monospace', fontSize: '0.95rem' }}>{ip}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div className="acp-card">
                <div className="acp-card-header">
                    <span className="acp-card-title">DNS Records</span>
                    <span className="os-doc-count">{DNS_RECORDS.length} record{DNS_RECORDS.length !== 1 ? 's' : ''}</span>
                </div>
                {DNS_RECORDS.length === 0 ? (
                    <div className="acp-empty">No DNS records configured</div>
                ) : (
                    <table className="acp-table">
                        <thead>
                            <tr><th>Name</th><th>URL</th></tr>
                        </thead>
                        <tbody>
                            {DNS_RECORDS.map(rec => (
                                <tr key={rec.url}>
                                    <td>{rec.label}</td>
                                    <td style={{ fontFamily: 'monospace', fontSize: '0.95rem' }}>
                                        <a href={rec.url} target="_blank" rel="noopener noreferrer">{rec.url}</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {SYNC_HEALTH_CURL && (
                <div className="acp-card">
                    <div className="acp-card-header">
                        <span className="acp-card-title">Sync Health Check</span>
                    </div>
                    <div style={{ padding: '1.25rem' }}>
                        <p style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: 1.5, margin: '0 0 0.875rem' }}>
                            Verify the sync API is reachable. A healthy response is <code style={codeChip}>200</code> with{' '}
                            <code style={codeChip}>{'{ "status": "ok" }'}</code>.
                        </p>
                        <div style={{ display: 'flex', alignItems: 'stretch', gap: 8 }}>
                            <code style={{
                                flex: 1, minWidth: 0, fontFamily: 'monospace', fontSize: '0.85rem',
                                background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 6,
                                padding: '10px 12px', overflowX: 'auto', whiteSpace: 'nowrap', color: '#111827',
                            }}>
                                {SYNC_HEALTH_CURL}
                            </code>
                            <button
                                type="button"
                                onClick={handleCopy}
                                style={{
                                    flexShrink: 0, border: `1px solid ${copied ? '#86efac' : '#d1d5db'}`, borderRadius: 6,
                                    padding: '0 16px', background: copied ? '#dcfce7' : '#fff',
                                    color: copied ? '#166534' : '#374151', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer',
                                }}
                            >
                                {copied ? '✓ Copied' : 'Copy'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
